import MuiFormHelperText from '@mui/material/FormHelperText';
import styled from 'styled-components';

import 'react-datepicker/dist/react-datepicker.css';

type InputProps = {
    $inputSize: 's' | 'm';
    error?: boolean;
    $helperTextStatic?: boolean;
};

export const DatePickerContainer = styled.div<InputProps>`
    position: relative;

    &.datepicker-open {
        .react-datepicker-wrapper {
            .react-datepicker__input-container {
                border-color: ${(props) =>
                    props.error ? props.theme.palette.secondaryA4 : props.theme.palette.primaryA1};

                &:hover {
                    border-color: ${(props) =>
                        props.error
                            ? props.theme.palette.secondaryA4
                            : props.theme.palette.primaryA1};
                }
            }
        }
    }

    .react-datepicker-wrapper {
        width: 100%;

        .react-datepicker__input-container {
            box-shadow: none;
            border-color: ${(props) =>
                props.error ? props.theme.palette.secondaryA4 : props.theme.palette.primaryA4};
            border-width: 1px;
            border-style: solid;
            background-color: ${(props) => props.theme.palette.primaryA6} !important;
            border-radius: 8px;
            ${(props) => props.theme.typography.smallTextBold}
            ${(props) => {
                switch (props.$inputSize) {
                    case 's':
                        return {
                            padding: '7px 12px',
                            minHeight: 32,
                            maxHeight: 32,
                        };
                    case 'm':
                        return {
                            padding: '13px 12px',
                            minHeight: 44,
                            maxHeight: 44,
                        };
                    default:
                        return {
                            padding: '13px 12px',
                            minHeight: 44,
                            maxHeight: 44,
                        };
                }
            }};
        }
    }

    .datepicker-input {
        ${(props) => props.theme.typography.smallTextBold}
        color: ${(props) => props.theme.palette.textMain};
        padding: 0;
        background-color: ${(props) => props.theme.palette.primaryA6};
        border: none;
        width: 100%;

        &::placeholder {
            color: ${(props) => props.theme.palette.textLight};
        }

        &:disabled {
            cursor: default;
            // same as Mui uses for disabled state
            -webkit-text-fill-color: rgba(0, 0, 0, 0.38);
        }
    }

    .react-datepicker__close-icon {
        display: flex;
        align-items: center;
        right: 32px;

        &:hover {
            .clear-icon {
                color: ${(props) => props.theme.palette.primaryA1};
            }
        }
    }

    &.datepicker-no-icon {
        .react-datepicker__close-icon {
            right: 6px;
        }
    }
    .clear-icon {
        transition: all 0.3s;
        width: 16px;
        height: 16px;
        color: ${(props) => props.theme.palette.primaryA3};
    }

    .react-datepicker__close-icon::after {
        display: none;
    }
    .react-datepicker__calendar-icon {
        width: auto;
        height: auto;
        padding: 8px !important;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 2px;
        z-index: 10;
    }

    .calendar-icon {
        color: ${(props) => props.theme.palette.primaryA2};
    }
`;

export const FormHelperText = styled(MuiFormHelperText)<Pick<InputProps, '$helperTextStatic'>>`
    ${(props) => props.theme.typography.smallTextBold}
    color: ${(props) => props.theme.palette.secondaryA4};

    ${(props) => {
        if (!props.$helperTextStatic) {
            return {
                position: 'absolute',
                left: 0,
                width: 'max-content',
                bottom: '-20px',
            };
        }

        return {
            alignSelf: 'start',
            marginLeft: '14px',
            marginRight: '14px',
        };
    }}
    .helper-container {
        display: flex;
        flex-direction: column;
        gap: 2px;

        .hint {
            ${(props) => props.theme.typography.smallTextBold}
            color: ${(props) => props.theme.palette.textLight};
        }
    }
`;
